export default {"src":"/_next/static/media/user.d81ac603.svg","height":14,"width":14};